/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMainAliases {
  ALLERGIE_DETAIL_FRAGMENT = 'allergie-detail-fragment',
  ALLERGIE_FRAGMENT = 'allergie-fragment',
  ALLERGIES_FRAGMENT = 'allergies-fragment',
  AVATAR_ITEM_DECK = 'avatar-item-deck',
  CARD_ITEM_DECK = 'card-item-deck',
  CONTEXTUAL_SIDEBAR = 'contextual-sidebar',
  DECK_ITEMS_SIDEBAR = 'deck-items-sidebar',
  DISCHARGE_SUMMARY_FRAGMENT = 'discharge-summary-fragment',
  LAYOUT_GENERAL = 'layout-general',
  LAYOUT_MY_CHART_MAIN = 'layout-my-chart-main',
  MEDICINE_FRAGMENT = 'medicine-fragment',
  MEDICINE_HOSPITAL_DETAIL_FRAGMENT = 'medicine-hospital-detail-fragment',
  MEDICINE_PATIENT_DETAIL_FRAGMENT = 'medicine-patient-detail-fragment',
  MEDICINE_PATIENT_FRAGMENT = 'medicine-patient-fragment',
  MY_CHART_ALLERGIE_DETAIL_ROUTE = 'my-chart-allergie-detail-route',
  MY_CHART_ALLERGIE_NEW_ROUTE = 'my-chart-allergie-new-route',
  MY_CHART_ALLERGIES_ROUTE = 'my-chart-allergies-route',
  MY_CHART_DISCHARGE_SUMMARY = 'my-chart-discharge-summary',
  MY_CHART_MEDICINE_HOSPITAL_DETAIL_ROUTE = 'my-chart-medicine-hospital-detail-route',
  MY_CHART_MEDICINE_PATIENT_DETAIL_ROUTE = 'my-chart-medicine-patient-detail-route',
  MY_CHART_MEDICINE_PATIENT_ROUTE = 'my-chart-medicine-patient-route',
  MY_CHART_MEDICINE_ROUTE = 'my-chart-medicine-route',
  MY_CHART_PAST_HISTORY_FORM_ROUTE = 'my-chart-past-history-form-route',
  MY_CHART_PAST_HISTORY_HOSPITAL_DETAIL_ROUTE = 'my-chart-past-history-hospital-detail-route',
  MY_CHART_PAST_HISTORY_INACTIVATE_ROUTE = 'my-chart-past-history-inactivate-route',
  MY_CHART_PAST_HISTORY_PATIENT_DETAIL_ROUTE = 'my-chart-past-history-patient-detail-route',
  MY_CHART_PAST_HISTORY_ROUTE = 'my-chart-past-history-route',
  MY_CHART_PRESCRIPTIONS_ROUTE = 'my-chart-prescriptions-route',
  MY_CHART_SEND_NEW_DOCUMENT_ROUTE = 'my-chart-send-new-document-route',
  MY_CHART_SENDING_DOCUMENTS_ROUTE = 'my-chart-sending-documents-route',
  MY_CHART_SICK_NOTE_ROUTE = 'my-chart-sick-note-route',
  MY_CHART_SUMMARY_DETAILS = 'my-chart-summary-details',
  MY_CHART_TELECONSULTATION_RECORDS_CARD = 'my-chart-teleconsultation-records-card',
  MY_CHART_TELEHEALTH_RECORDS = 'my-chart-telehealth-records',
  MY_CHART_VACCINE_DETAIL_ROUTE = 'my-chart-vaccine-detail-route',
  MY_CHART_VACCINES_ROUTE = 'my-chart-vaccines-route',
  PANEL_MY_CHART_SIDEBAR = 'panel-my-chart-sidebar',
  PANEL_MY_CHAT_CONTENT = 'panel-my-chat-content',
  PAST_HISTORY_FORM_FRAGMENT = 'past-history-form-fragment',
  PAST_HISTORY_FRAGMENT = 'past-history-fragment',
  PAST_HISTORY_HOSPITAL_DETAIL_FRAGMENT = 'past-history-hospital-detail-fragment',
  PAST_HISTORY_INACTIVATE_FRAGMENT = 'past-history-inactivate-fragment',
  PAST_HISTORY_PATIENT_DETAIL_FRAGMENT = 'past-history-patient-detail-fragment',
  PRESCRIPTIONS_FRAGMENT = 'prescriptions-fragment',
  SEND_NEW_DOCUMENT_FRAGMENT = 'send-new-document-fragment',
  SENDING_DOCUMENTS_FRAGMENT = 'sending-documents-fragment',
  SICK_NOTE_FRAGMENT = 'sick-note-fragment',
  SUMMARY_FRAGMENT_DETAILS = 'summary-fragment-details',
  VACCINE_DETAIL_FRAGMENT = 'vaccine-detail-fragment',
  VACCINES_FRAGMENT = 'vaccines-fragment',
}
export { MyChartMainAliases };
